export const DOMAIN_PART_REGEX = /^[a-z0-9][a-z0-9-]*[a-z0-9]$/;

export function isValidDomainPart(part: string): boolean {
  return DOMAIN_PART_REGEX.test(part);
}

// From: https://d32ze2gidvkk54.cloudfront.net/Amazon_Route_53_Domain_Registration_Pricing_20140731.pdf
// Removed some TLDs that:
// - Do not support domain privacy (.us)
// - Might run afounl of S.H.A.F.T. filtering (.porn, etc)
// - Cost more than $100/yr (we can still buy and import these, but don't offer them proactively)
export const AVAILABLE_TLDS = [
  ".ac",
  ".academy",
  ".accountants",
  ".actor",
  ".agency",
  ".airforce",
  ".apartments",
  ".army",
  ".associates",
  ".attorney",
  ".au",
  ".auction",
  ".audio",
  ".band",
  ".bargains",
  ".be",
  ".berlin",
  ".bet",
  ".bid",
  ".bike",
  ".bingo",
  ".bio",
  ".biz",
  ".black",
  ".blue",
  ".boutique",
  ".builders",
  ".business",
  ".buzz",
  ".ca",
  ".cab",
  ".cafe",
  ".camera",
  ".camp",
  ".capital",
  ".cards",
  ".care",
  ".careers",
  ".casa",
  ".catering",
  ".cc",
  ".center",
  ".ch",
  ".chat",
  ".cheap",
  ".christmas",
  ".church",
  ".city",
  ".cl",
  ".claims",
  ".cleaning",
  ".click",
  ".clinic",
  ".clothing",
  ".cloud",
  ".club",
  ".co",
  ".co.nz",
  ".co.uk",
  ".co.za",
  ".coach",
  ".codes",
  ".coffee",
  ".college",
  ".com",
  ".com.ar",
  ".com.au",
  ".com.br",
  ".com.mx",
  ".com.sg",
  ".community",
  ".company",
  ".computer",
  ".condos",
  ".construction",
  ".consulting",
  ".contact",
  ".contractors",
  ".cool",
  ".coupons",
  ".cruises",
  ".cz",
  ".dance",
  ".de",
  ".deals",
  ".degree",
  ".delivery",
  ".democrat",
  ".dental",
  ".dentist",
  ".design",
  ".diamonds",
  ".diet",
  ".digital",
  ".direct",
  ".directory",
  ".discount",
  ".fan",
  ".farm",
  ".fashion",
  ".fi",
  ".finance",
  ".financial",
  ".fish",
  ".fitness",
  ".flights",
  ".florist",
  ".flowers",
  ".football",
  ".forsale",
  ".foundation",
  ".fr",
  ".fun",
  ".fund",
  ".futbol",
  ".fyi",
  ".gallery",
  ".games",
  ".garden",
  ".gg",
  ".gift",
  ".gifts",
  ".gives",
  ".glass",
  ".global",
  ".gmbh",
  ".hosting",
  ".house",
  ".im",
  ".immo",
  ".immobilien",
  ".in",
  ".industries",
  ".info",
  ".ink",
  ".institute",
  ".insure",
  ".international",
  ".io",
  ".irish",
  ".it",
  ".jetzt",
  ".jewelry",
  ".jp",
  ".juegos",
  ".kaufen",
  ".kim",
  ".kitchen",
  ".kiwi",
  ".land",
  ".law",
  ".lawyer",
  ".lease",
  ".legal",
  ".lgbt",
  ".life",
  ".lighting",
  ".limited",
  ".limo",
  ".link",
  ".live",
  ".llc",
  ".loan",
  ".lol",
  ".ltd",
  ".maison",
  ".management",
  ".market",
  ".marketing",
  ".mba",
  ".me",
  ".me.uk",
  ".media",
  ".memorial",
  ".mobi",
  ".moda",
  ".money",
  ".mortgage",
  ".mx",
  ".name",
  ".navy",
  ".net",
  ".net.au",
  ".net.nz",
  ".network",
  ".news",
  ".ninja",
  ".nl",
  ".onl",
  ".online",
  ".org",
  ".org.nz",
  ".org.uk",
  ".partners",
  ".parts",
  ".photo",
  ".photography",
  ".photos",
  ".pics",
  ".pictures",
  ".pink",
  ".pizza",
  ".place",
  ".plumbing",
  ".plus",
  ".press",
  ".pro",
  ".productions",
  ".properties",
  ".property",
  ".pw",
  ".qa",
  ".qpon",
  ".recipes",
  ".red",
  ".rehab",
  ".reisen",
  ".rentals",
  ".repair",
  ".report",
  ".republican",
  ".restaurant",
  ".reviews",
  ".rip",
  ".rocks",
  ".ru",
  ".ruhr",
  ".run",
  ".sale",
  ".salon",
  ".sarl",
  ".school",
  ".schule",
  ".se",
  ".services",
  ".sg",
  ".sh",
  ".shiksha",
  ".shoes",
  ".shopping",
  ".show",
  ".site",
  ".ski",
  ".soccer",
  ".social",
  ".software",
  ".solar",
  ".solutions",
  ".space",
  ".store",
  ".stream",
  ".studio",
  ".style",
  ".supplies",
  ".supply",
  ".support",
  ".surgery",
  ".systems",
  ".tattoo",
  ".tax",
  ".taxi",
  ".team",
  ".tech",
  ".technology",
  ".tennis",
  ".theater",
  ".tienda",
  ".tips",
  ".today",
  ".tools",
  ".tours",
  ".town",
  ".toys",
  ".trade",
  ".training",
  ".tv",
  ".uk",
  ".university",
  ".uno",
  ".vacations",
  ".vc",
  ".vegas",
  ".ventures",
  ".vet",
  ".vg",
  ".viajes",
  ".video",
  ".villas",
  ".vin",
  ".vip",
  ".vision",
  ".vote",
  ".voyage",
  ".watch",
  ".website",
  ".wedding",
  ".wien",
  ".wiki",
  ".work",
  ".works",
  ".world",
  ".wtf",
  ".xyz",
  ".yoga",
  ".zone",
];
